import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import PrivateRoute from "./private-route";
import PLTable from "../components/pl-table";
import { appSlugs, tokenMainKeys } from "../../../utils/constants";
import PlReport from "../components/pl-report";
//import PlSection from "../components/pl-sections";
import Sales from "../components/sales";
export const plReportsRouteConfig = {
  mainPath: {
    path: "/",
    element: <PrivateRoute />,
    exact: true,
    Element: PrivateRoute,
  },
  mainRoute: "/pl-report",
  routes: [
    {
      path: "/",
      Element: PlReport,
      element: <PlReport />,
      exact: true,
    },
  ],
};

const PLReportsRoutes = ({
  token = tokenMainKeys.plReport,
  slug = appSlugs.plReport,
}) => {
  return (
    <Routes>
      <Route
        exact
        path="/"
        element={<PrivateRoute token={token} slug={slug} />}
      >
        <Route path="/" element={<Navigate to="summary" replace />} />
        <Route
          path="/summary"
          element={<PlReport token={token} slug={slug} />}
        />
        <Route path="/sales" element={<Sales token={token} slug={slug} />} />
      </Route>
    </Routes>
  );
};

export default PLReportsRoutes;
